import React from 'react';
import { Table } from 'components/common';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import 'dayjs/locale/pl';
import 'dayjs/locale/en';
import { Tooltip } from 'antd';

type Props = {
    screenings: MammographicScreening[];
    onRowSelect: (value: number | null) => void;
    choosenId: number | null;
};

const MammographyTable: React.FC<Props> = ({ screenings, onRowSelect, choosenId }) => {
    const { t, i18n } = useTranslation(['table', 'examinationDetails']);
    const columns = [
        {
            title: t('table:mammography', { returnObjects: true }).createdAt,
            key: 'createdAt',
            render: ({ screening }: MammographicScreening) => {
                const createdAt = dayjs(screening.createdAt).locale(i18n.language);
                return `${createdAt.format('DD MMMM YYYY')}
                        ${createdAt.format('HH:mm')}`;
            },
        },
        {
            title: t('examinationDetails:referral'),
            render: ({ screening }: MammographicScreening) =>
                screening.screeningDescriptionsStatus === 'desc_all_completed'
                    ? t('table:mammography', { returnObjects: true }).check.toUpperCase()
                    : t('table:mammography', { returnObjects: true }).during_desc.toUpperCase(),
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={screenings}
            onRowSelect={onRowSelect}
            choosenRowId={choosenId}
            locale={{ emptyText: t('table:mammography', { returnObjects: true }).empty }}
        />
    );
};

export default MammographyTable;
